import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";

import * as api from "../services";
import AppContext from "../appContext";
import useSettings from "./useSettings";

export default function useSaveSettings() {
  const queryClient = useQueryClient();
  const {
    app: {
      client: { id: clientId },
      sessionId,
      project: { id: projectId },
    },
  } = useContext(AppContext);
  const { settings } = useSettings();
  // replace the current moodboard to the client
  const saveSetting = useMutation(
    (setting) => {
      let newSettings = { ...settings };
      Object.keys(setting).forEach((key) => (newSettings[key] = setting[key]));
      const settingsJSON = JSON.stringify(newSettings);
      return api.postSettings({
        id: clientId,
        settingsJSON,
        sessionId,
        projectId,
      });
    },
    {
      onSuccess: (data) => {
        if (data.data?.status > 0) {
          //refetchSettings();
          queryClient.invalidateQueries("settings");
          //queryClient.setQueryData('settings', old => ({...old, newTodo}))
        }
      },
    }
  );
  return saveSetting;
}
